export function merge(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i]
    if(source) {
      for (let prop in source) {
        if (source.hasOwnProperty(prop)) {
          let value = source[prop]
          target[prop] = value
        }
      }
    }
  }
  return target
}

export function format(date, fmt,status) {
  if(status === "terday"){
    date.setDate(date.getDate() - 1);
  }
  let o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function getQueryString(url,name) {
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = url.substr(url.indexOf('?')+1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}

export function isEmpty(obj) {
  for (var name in obj) {
    return false
  }
  return true
}

export function formatSpace (s) {
  if(s < 1024) {
    return s+"B";
  } else if (s < 1024*1024) {
    return (s/1024).toFixed(2) +"KB"
  } else if (s < 1024*1024*1024) {
    return (s/1024/1024).toFixed(2) + "MB"
  } else if (s < 1024*1024*1024*1024) {
    return (s/1024/1024/1024).toFixed(2) + "GB"
  } else if (s < 1024*1024*1024*1024*1024) {
    return (s/1024/1024/1024/1024).toFixed(2) + "TB"
  }
}

export function formatDuration (s) {
  if(s < 60) {
    return s+"秒";
  } else if (s < 60*60) {
    return parseInt(s/60) +"分"+s%60 + "秒"
  } else if (s < 60*60*60) {
    var seconds = s%(60*60);
    return parseInt(s/60/60) + "小时" + parseInt(seconds/60) + "分" + seconds%60 + "秒"
  } else{
    var seconds = s%(60*60)
    return parseInt(s/60/60) + "小时" + parseInt(seconds/60) + "分" + seconds%60 + "秒"
  }
}

export function buildTree(data,valueMap,forBidden) {
  var hashData = {};
  var p_id = [];
  if(data&&data.length>0) {
    data.map(v=>{
      v.parent_id = v.parent_id || 0;
      if(!hashData[v.parent_id]) {
        hashData[v.parent_id] = [];
      }
      hashData[v.parent_id].push(v);
    });
  }
  for(let item in hashData){
    p_id.push(item)
  }
  // var tree = innerBuildTree(hashData,0,valueMap,false)
  var tree = innerBuildTree(hashData,p_id[0],valueMap,false,forBidden)
  return tree;
}

function innerBuildTree(hashData,parent_id,valueMap,parent_checked,forbidden) {
  var parent_id = parent_id || 0;
  var tree = [];
  var data = hashData[parent_id];
  if(data&&data.length>0) {
    data.map(v=> {
      var checked = valueMap[v.id]?true:parent_checked;
      var children = innerBuildTree(hashData, v.id,valueMap,checked,forbidden)
      var selected = children.filter(v=>v.checked==true || v.indeterminate==true).length;
      var indeterminate = (selected > 0&&!checked);
      var disabled = false;
      if(typeof(forbidden) === 'number'){
        disabled = forbidden === v.app_id ? true:false
      }else if(forbidden === true){
        disabled = v.virtual
      }
      tree.push({
        id: v.id,
        checked:checked,
        label: v.system ? `${v.name}(${v.system})` :v.name,
        data: v,
        visible:true,
        indeterminate:indeterminate,
        children: children,
        // disabled: typeof(dataid) == 'number' ? (dataid === v.app_id ? true:false) : dataid,
        disabled: disabled,
      })
    })
  }
  return tree;
}

export const decodeBase64 = (content, maxLength = 0) => {
  try {
      const decode = Base64.decode(content);
      if (maxLength <= 0 || decode.length <= maxLength) {
          return decode;
      }
      return decode.substring(0, maxLength) + '...';
  } catch (e) {
      return content
  }
};

export const decodeHtmlEntities = (encodedString) => {
  const entities = [
      ['&lt;', '<'],
      ['&gt;', '>'],
      ['&amp;', '&'],
      ['&quot;', '"'],
      ['&apos;', "'"],
      ['“', "\""],
      ['”', "\""]
  ];

  for (const [entity, replacement] of entities) {
      encodedString = encodedString.replace(new RegExp(entity, 'g'), replacement);
  }
  return encodedString;
}

export const isNotEmpty = (value) => {
  return !isEmpty(value)
}
